import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, FieldText, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { useCallback, useEffect, useState } from 'react';
import { validateName } from 'utils/formValidator';
import PrettyNumber from '../PrettyNumber';
import styles from './renameFlowModal.module.scss';
const RenameFlowModal = ({ isShown, selectedFlow, number, flows, onClose, }) => {
    const { name = '' } = selectedFlow || {};
    const [isLoading, setIsLoading] = useState(false);
    const [value, setValue] = useState(name || '');
    useEffect(() => {
        setValue(name || '');
    }, [name]);
    const onChange = useCallback((event) => {
        if (!event) {
            return;
        }
        const { target: { value }, } = event;
        setValue(value);
    }, [setValue]);
    const onSave = useCallback(() => {
        if (!selectedFlow) {
            return;
        }
        const { id } = selectedFlow;
        setIsLoading(true);
        flows
            .update(id, Object.assign(Object.assign({}, selectedFlow), { name: value }))
            .then(() => setIsLoading(false))
            .then(() => onClose());
    }, [value, selectedFlow, flows, setIsLoading, onClose]);
    if (!selectedFlow) {
        return null;
    }
    return (_jsxs(Modal, Object.assign({ isOpen: isShown, onClose: onClose }, { children: [_jsx(ModalHead, { title: "Rename flow", onClose: onClose }), _jsxs(ModalBody, { children: [_jsxs("p", Object.assign({ className: styles.text }, { children: ["You are about to rename the flow for number", ' ', _jsx("strong", { children: _jsx(PrettyNumber, { number: number }) })] })), _jsx(FieldText, { meta: {
                            error: validateName(value),
                        }, input: { value, name: 'name', onChange }, label: "Name" })] }), _jsx(ModalFoot, { children: _jsx(Button, Object.assign({ isLoading: isLoading, onClick: onSave }, { children: "Save" })) })] })));
};
export default RenameFlowModal;
